import React from "react";
import Header from "../layouts/Header/";
import Footer from "../layouts/Footer";
import SectionHeading from "../components/SectionHeading";

const SocialMediaSentimentAI = () => {
  return (
    <>
      <Header />

     

      <section className="section-padding-100 service_single_content_area">
        <div className="container">
          <div className="row">
            <div className="col-12 col-md-10 offset-md-1">
              <div className="service_single_content text-center mb-100">
                <SectionHeading
                  title="Social Media Sentiment AI"
                  text="Discover Trending Cryptocurrencies Through Social Analysis"
                />
                
                <div className="service_content_area text-left mt-50">
                  <div className="coming-soon-badge mb-30">
                    <span className="badge badge-pill badge-warning p-3">Coming Soon</span>
                  </div>
                  
                  <p className="w-text">
                    Our Social Media Sentiment AI is an innovative tool designed to scan social media text and videos 
                    to analyze cryptocurrency sentiment across various platforms. The AI suggests coins based on 
                    comprehensive social media sentiment analysis and identifies new trending cryptocurrencies 
                    before they gain mainstream attention.
                  </p>
                  
                  <div className="service_features mt-30">
                    <h4 className="w-text">Upcoming Features:</h4>
                    <ul className="w-text list-unstyled" style={{ color: 'white' }}>
                      <li className="mb-2"><i className="fa fa-check me-2"></i> Scans multiple platforms (X, Reddit, YouTube, Discord, Telegram)</li>
                      <li className="mb-2"><i className="fa fa-check me-2"></i> Analyzes crypto discussions in real-time</li>
                      <li className="mb-2"><i className="fa fa-check me-2"></i> Detects cryptocurrency mentions in videos</li>
                      <li className="mb-2"><i className="fa fa-check me-2"></i> Identifies trending coins via social momentum</li>
                      <li className="mb-2"><i className="fa fa-check me-2"></i> Provides sentiment alerts and notifications</li>
                      <li className="mb-2"><i className="fa fa-check me-2"></i> Tracks historical sentiment trends</li>
                    </ul>
                  </div>
                  
                  <div className="service_features mt-30">
                    <h4 className="w-text" style={{ color: 'white' }}>Potential Applications:</h4>
                    <ul className="w-text list-unstyled" style={{ color: 'white' }}>
                      <li className="mb-2"><i className="fa fa-check me-2"></i> Spots emerging cryptocurrencies early</li>
                      <li className="mb-2"><i className="fa fa-check me-2"></i> Correlates market sentiment with price movements</li>
                      <li className="mb-2"><i className="fa fa-check me-2"></i> Assesses influencer impact on cryptocurrencies</li>
                      <li className="mb-2"><i className="fa fa-check me-2"></i> Measures community growth for projects</li>
                      <li className="mb-2"><i className="fa fa-check me-2"></i> Develops sentiment-based investment strategies</li>
                    </ul>
                  </div>
                  

            
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default SocialMediaSentimentAI;